import { FunctionComponent } from "react";
import { useHistory } from 'react-router-dom';
import { SK_CHAT_DETAIL_HEADER_CLASS } from "../../../constants/sidekick";
import { Button, IconButton } from "@panviva/panviva-react-ui";
import { truncateToWords } from "../../../utils/transformers/sidekickTransformers";
import "./ChatDetailHeader.scss";

interface ChatDetailHeaderProps {
    title: string;
}

export const ChatDetailHeader: FunctionComponent<ChatDetailHeaderProps> = ({ title }) => {
    const history = useHistory();
    const { text: truncatedTitle, isTruncated } = truncateToWords(title, 10);

    return (
        <div className={SK_CHAT_DETAIL_HEADER_CLASS} data-testid="sk-chat-detail-header">
            <h1 title={isTruncated ? title : undefined}>{truncatedTitle}</h1>
            {/* Export button hidden until functionality is implemented
            <div className="export-button">
                <Button variant="contained">Export</Button>
            </div>
            */}
        </div>
    );
}